import React, { useState } from 'react';
import { Card, Tabs, Table, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerDelivery } from '@/hooks/useManufacturingControlTower';
import { DeliveryReadinessKpiBar } from '@/components/sales/DeliveryReadinessKpiBar';
import { CreateDeliveryFromReadinessModal } from '@/components/sales/CreateDeliveryFromReadinessModal';
import type { DeliveryReadinessRow } from '@/services/delivery.service';

const DeliveryReadinessCenter: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const navigate = useNavigate();
  const { data, isLoading, refetch } = useControlTowerDelivery(filters);
  const board = data as {
    kpis?: Record<string, number>;
    ready?: DeliveryReadinessRow[];
    partial?: DeliveryReadinessRow[];
    blocked?: DeliveryReadinessRow[];
  };
  const [createOpen, setCreateOpen] = useState(false);

  const cols = [
    { title: 'WO', dataIndex: 'work_order_number', width: 110 },
    { title: 'Customer', dataIndex: 'customer_name' },
    { title: 'Item', dataIndex: 'item_description', ellipsis: true },
    { title: 'Available', dataIndex: 'available_quantity', width: 90 },
    { title: 'Status', dataIndex: 'readiness_status', width: 100 },
  ];

  const tabItems = [
    { key: 'ready', label: `Ready (${board?.ready?.length ?? 0})`, children: <Table size="small" rowKey="row_key" columns={cols} dataSource={board?.ready ?? []} pagination={{ pageSize: 10 }} /> },
    { key: 'partial', label: `Partial (${board?.partial?.length ?? 0})`, children: <Table size="small" rowKey="row_key" columns={cols} dataSource={board?.partial ?? []} pagination={{ pageSize: 10 }} /> },
    { key: 'blocked', label: `Blocked (${board?.blocked?.length ?? 0})`, children: <Table size="small" rowKey="row_key" columns={cols} dataSource={board?.blocked ?? []} pagination={{ pageSize: 10 }} /> },
  ];

  return (
    <Card
      id="delivery"
      title="Delivery readiness center"
      extra={
        <Space>
          <Button size="small" onClick={() => navigate('/growth/delivery-readiness')}>
            Open board
          </Button>
          <Button type="primary" size="small" onClick={() => setCreateOpen(true)}>
            Create DN
          </Button>
        </Space>
      }
      style={{ marginTop: 16 }}
      loading={isLoading}
    >
      {board?.kpis ? (
        <DeliveryReadinessKpiBar
          kpis={{
            readyToday: board.kpis.readyToday ?? 0,
            readyUnits: board.kpis.readyUnits ?? 0,
            blockedCount: board.kpis.blockedCount ?? 0,
            pendingDispatches: board.kpis.pendingDispatches ?? 0,
            todaysDeliveryNotes: board.kpis.todaysDeliveryNotes ?? 0,
            overdueDeliveries: board.kpis.overdueDeliveries ?? 0,
          }}
          loading={isLoading}
        />
      ) : null}
      <Tabs items={tabItems} style={{ marginTop: 12 }} />
      <CreateDeliveryFromReadinessModal
        open={createOpen}
        rows={board?.ready ?? []}
        onClose={() => setCreateOpen(false)}
        onSuccess={() => {
          setCreateOpen(false);
          refetch();
        }}
      />
    </Card>
  );
};

export default DeliveryReadinessCenter;
